import { gql } from '@apollo/client';

// **************************************************
//                    FRAGMENTS
// **************************************************
export const RailzIntegration = gql`
  fragment RailzIntegration on RailzIntegration {
    id
    railzBusinessId
    railzConnectionId
    railzServiceName
    organizationId
    created_at
    deletedAt
  }
`;

// **************************************************
//                     QUERIES
// **************************************************
export const GET_ACTIVE_RAILZ_CONNECTION_BY_ORG_ID = gql`
  query GetActiveRailzConnectionsByOrgId($organizationId: UUID!) {
    connections: getActiveRailzConnectionsByOrgId(
      organizationId: $organizationId
    ) {
      ...RailzIntegration
    }
  }
`;

export const GET_FINANCIAL_STATEMENT_DATA_BY_DATE_RANGE = gql`
  query GetFinancialStatementDataByDateRange(
    $startDate: FullDateStr!
    $endDate: FullDateStr!
    $financialStatement: FinancialStatementType!
    $reportFrequency: ReportFrequency!
    $creditFacilityId: UUID!
  ) {
    getFinancialStatementDataByDateRange(
      startDate: $startDate
      endDate: $endDate
      financialStatement: $financialStatement
      reportFrequency: $reportFrequency
      creditFacilityId: $creditFacilityId
    ) {
      currency
      finleyStatementKey
      reportFrequency
      metadata {
        sortedEndOfPeriodDates
      }
      adHocCalculations {
        adHocKey
        totals {
          cadenceDelta
          endOfPeriodDate
          value
        }
      }
      sectionKeysToLineItems {
        finleySectionKey
        totals {
          cadenceDelta
          endOfPeriodDate
          value
        }
        lineItemsToValues {
          lineItemDescription
          values {
            cadenceDelta
            endOfPeriodDate
            value
            finStatementLineItemId
            finStatementId
          }
        }
      }
    }
  }
`;

export const DOES_FINANCIAL_STATEMENT_ATHENA_TABLE_EXIST = gql`
  query doesFinancialsAthenaTableExist($creditFacilityId: UUID!) {
    doesFinancialsAthenaTableExist(creditFacilityId: $creditFacilityId)
  }
`;

// **************************************************
//                    MUTATIONS
// **************************************************
export const CREATE_RAILZ_INTEGRATION = gql`
  mutation CreateRailzIntegration(
    $organizationId: UUID!
    $railzBusinessId: String!
    $railzConnectionId: String!
    $railzServiceName: RailzAccountingServiceNames!
  ) {
    connection: createRailzIntegration(
      organizationId: $organizationId
      railzBusinessId: $railzBusinessId
      railzConnectionId: $railzConnectionId
      railzServiceName: $railzServiceName
    ) {
      ...RailzIntegration
    }
  }
`;

export const DISCONNECT_RAILZ_INTEGRATION = gql`
  mutation DisconnectRailzIntegration($railzIntegrationId: UUID!) {
    connection: disconnectRailzIntegration(
      railzIntegrationId: $railzIntegrationId
    ) {
      ...RailzIntegration
    }
  }
`;

export const FETCH_AND_UPLOAD_FINANCIAL_DATA_FROM_RAILZ = gql`
  mutation FetchAndUploadFinancialDataFromRailz(
    $railzIntegrationId: UUID!
    $queryParamInputs: RailzFinancialApiQueryParams!
  ) {
    dataCount: fetchAndUploadFinancialDataFromRailz(
      railzIntegrationId: $railzIntegrationId
      queryParamInputs: $queryParamInputs
    )
  }
`;

export const UPDATE_FIN_STATEMENT_LINE_ITEM = gql`
  mutation UpdateFinStatementLineItem(
    $updateInput: UpdateFinStatementLineItemInput!
  ) {
    updateFinStatementLineItem(updateInput: $updateInput) {
      response
    }
  }
`;

export const CREATE_FIN_STATEMENT_LINE_ITEM = gql`
  mutation CreateFinStatementLineItem(
    $finStatementLineItem: CreateFinStatementLineItemInput!
  ) {
    createFinStatementLineItem(finStatementLineItem: $finStatementLineItem) {
      response
    }
  }
`;

export const DELETE_FIN_STATEMENT_LINE_ITEM = gql`
  mutation DeleteFinStatementLineItem($finStatementLineItemId: UUID!) {
    deleteFinStatementLineItem(
      finStatementLineItemId: $finStatementLineItemId
    ) {
      response
    }
  }
`;

export const DELETE_FIN_STATEMENT = gql`
  mutation DeleteFinStatement($finStatementId: UUID!) {
    deleteFinStatement(finStatementId: $finStatementId) {
      response
    }
  }
`;

export const GET_FINANCIAL_STATEMENT_CONFIG = gql`
  query GetFinancialStatementConfig($organizationSlug: String!) {
    getFinancialStatementConfig(organizationSlug: $organizationSlug) {
      financialFormatting {
        displayFormat
      }
    }
  }
`;
